<template>
  <form @submit.prevent="handleSubmit">
    <div class="single-remove-grid">
      <div class="single-remove-copy">
        <label class="active teal-text">Single Principal Removal</label>
        <h6>Move one principal (and their family) to the Bin</h6>
        <p>
          This updates the principal, spouse, and dependants to removed status.
          Pending and unpaid invoices for this principal are also cleared.
        </p>
      </div>

      <div class="single-remove-form">
        <div class="input-field">
          <input
            id="single_remove_enrollee_number"
            type="text"
            v-model.trim="enrolleeNumber"
          />
          <label for="single_remove_enrollee_number">Principal Enrollee ID</label>
        </div>

        <div v-if="message" class="remove-message success-message">
          <i class="material-icons">check_circle</i>
          <span>{{ message }}</span>
        </div>

        <div v-if="error" class="remove-message error-message">
          <i class="material-icons">error</i>
          <span>{{ error }}</span>
        </div>
      </div>
    </div>

    <div class="remove-submit-strip">
      <button
        class="waves-effect waves-light btn-large red darken-3"
        :class="{ disabled: !canSubmit }"
      >
        <i class="material-icons right">delete</i>
        {{ isSubmitting ? "Removing" : "Move to Bin" }}
      </button>
    </div>
  </form>
</template>

<script>
import { ref, computed, nextTick } from "vue";
import postItem from "@/composables/postItem";
import M from "materialize-css";

export default {
  name: "EnrolleeRemoveSingleOnboardComponent",
  emits: ["complete"],
  setup(props, context) {
    const enrolleeNumber = ref("");
    const error = ref(null);
    const message = ref(null);
    const isSubmitting = ref(false);

    const canSubmit = computed(() => {
      return enrolleeNumber.value && !isSubmitting.value;
    });

    const resetLabels = async () => {
      await nextTick();
      M.updateTextFields();
    };

    const handleSubmit = async () => {
      if (!canSubmit.value) {
        return;
      }

      isSubmitting.value = true;
      error.value = null;
      message.value = null;

      const payload = {
        enrollee_number: enrolleeNumber.value,
      };

      const { res, err } = await postItem("principal/remove", payload);

      if (res.value) {
        message.value = res.value.Success || "Principal family moved to Bin.";
        enrolleeNumber.value = "";
        context.emit("complete", { status: true });
        resetLabels();
      } else {
        error.value = err.value || "Single removal failed.";
      }

      isSubmitting.value = false;
    };

    return {
      canSubmit,
      enrolleeNumber,
      error,
      handleSubmit,
      isSubmitting,
      message,
    };
  },
};
</script>

<style scoped>
.single-remove-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(220px, 0.8fr) minmax(280px, 1.2fr);
}

.single-remove-copy {
  background: #fafafa;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  padding: 16px;
}

.single-remove-copy h6 {
  color: #263238;
  font-size: 1.05rem;
  font-weight: 700;
  margin: 6px 0 8px;
}

.single-remove-copy p {
  color: #607d8b;
  line-height: 1.55;
  margin: 0;
}

.single-remove-form {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  padding: 16px;
}

.remove-message {
  align-items: center;
  border-radius: 6px;
  display: flex;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 12px;
}

.remove-message i {
  font-size: 20px;
}

.success-message {
  background: #f1f8e9;
  color: #33691e;
}

.error-message {
  background: #ffebee;
  color: #b71c1c;
}

.remove-submit-strip {
  background: #f5f5f5;
  border-radius: 6px;
  margin-top: 18px;
  padding: 18px;
}

@media (max-width: 800px) {
  .single-remove-grid {
    grid-template-columns: 1fr;
  }
}
</style>
